import {
  type CustomFieldAddInput,
  type CustomFieldAddSuccess,
  type CustomFieldData,
  toResponseError,
  type UnsavedCustomField,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useCustomFieldCache } from './cache'

export function useAddCustomField(): AddHookResponse<UnsavedCustomField, CustomFieldData> {
  const cache = useCustomFieldCache()

  const mutation = useTantalimMutation<CustomFieldAddInput, CustomFieldAddSuccess>({
    url: '/customField/add',
  })

  async function add(unsaved: UnsavedCustomField): Promise<CustomFieldData> {
    try {
      const { customField } = await mutation.mutateAsync({ unsaved })
      cache.clearList()
      return customField
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
